import React from 'react';

class APIHandler extends React.Component{

    static URL = "https://api.eventtechnik.feedboost.de";
    //static URL = "http://localhost:4000";
    static APIToken = "49991BC21E1CBEA2473779B943C19F8AE360E5E5384D7F7780A43957265EA0A7";
}

export default APIHandler;